<template>
    <section>
        <div class="d-flex justify-content-between position-sticky service-header">
            <div>
                <span class="primary-color fsz-18 fw-bold me-2">{{ serviceTitle }}</span>
                <span class="accent-light-color fsz-18 fw-bold"
                    >{{ servicePrice > 0 ? servicePrice : '0.00' }} C</span
                >
            </div>
            <div>
                <button
                    class="selected-image-btn-project-overview"
                    @click="$emit('project-overview-event')"
                >
                    Project Overview
                </button>
                <button class="selected-image-btn-apply" @click="$emit('apply-event')">
                    <img v-show="loading" src="../../../assets/spinner.svg" /> {{ saveButtonText }}
                </button>
            </div>
        </div>
        <div class="selected-image-img-container position-relative">
            <img v-lazy="selectedImgSrc" alt="" />
            <div v-show="!imageLoaded" class="selected-image-loader">
                <div class="lds-dual-ring"></div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        selectedImgSrc: {
            type: String,
            default: '',
            require: true,
        },
        serviceTitle: {
            type: String,
            default: '',
            require: true,
        },
        saveButtonText: {
            type: String,
            default: 'Apply',
        },
        servicePrice: {
            type: Number,
            default: 0,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        imageLoaded() {
            return this.$store.getters['imageEnhancementServiceStore/getIsSelectedImageLoaded'];
        },
    },
};
</script>

<style lang="scss" scoped>
.selected-image {
    &-img-container {
        @include centerByFlex;
        width: 100%;
        height: 405px;
        margin: 8px 0;
        img {
            width: 90%;
            height: 100%;
            object-fit: contain;
            object-position: center;
            border-radius: 8px;
        }
    }
    &-btn {
        &-project-overview {
            border: 1px solid $Primary-Text-Color;
            height: 32px;
            outline: none;
            background-color: #fff;
            color: $Primary-Text-Color;
            font-size: 12px;
            border-radius: 56px;
            padding: 0 16px;
            margin-right: 8px;
        }
        &-apply {
            @include nextBtn(100px, 32px);
            font-size: 14px;
            font-weight: bold;
        }
    }
}
img[lazy='loading'] {
    width: 48px;
    height: 48px;
}
img[lazy='error'] {
    width: 48px;
    height: 48px;
}
.selected-image-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-color: white;
    z-index: 1000;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.lds-dual-ring {
    display: inline-block;
    width: 38px;
    height: 38px;
}
.lds-dual-ring:after {
    content: ' ';
    display: block;
    width: 38px;
    height: 38px;
    margin: 8px;
    border-radius: 50%;
    border: 4px solid #182485;
    border-color: #182485 transparent #182485 transparent;
    animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.service-header {
    top: 0px;
    z-index: 10;
    padding-bottom: 7px;
    background: white;
}
</style>
